const PREFIX = 'hero';

export const SPARTAN_PRODUCT_HERO_BANNER_TRACKING = {
  section: PREFIX,
  bg: `${PREFIX}-bg`,
  bgMedia: `${PREFIX}-bg-media`,
  car: `${PREFIX}-car`,
  parallaxCar: `${PREFIX}-parallax-car`,
  parallaxFrame: `${PREFIX}-parallax-frame`,
  parallaxScrollScene: `${PREFIX}-parallax-scroll-scene`,
  parallaxScene: `${PREFIX}-parallax-scene`,
  parallaxLayer: {
    back: `${PREFIX}-parallax-layer-back`,
    mid: `${PREFIX}-parallax-layer-mid`,
    front: `${PREFIX}-parallax-layer-front`,
    blur: `${PREFIX}-parallax-layer-blur`,
  },
  parallaxBg: {
    back: `${PREFIX}-parallax-bg-back`,
    mid: `${PREFIX}-parallax-bg-mid`,
    front: `${PREFIX}-parallax-bg-front`,
    blur: `${PREFIX}-parallax-bg-blur`,
  },
  overlayTop: `${PREFIX}-overlay-top`,
  overlayBottom: `${PREFIX}-overlay-bottom`,
  modelLogo: `${PREFIX}-model-logo`,
  engineLogo: `${PREFIX}-engine-logo`,
  specialLogo: `${PREFIX}-special-logo`,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  productName: `${PREFIX}-product-name`,
  tagline: `${PREFIX}-tagline`,
  specList: `${PREFIX}-spec-list`,
  spec: (index: number) => `${PREFIX}-spec-${index + 1}`,
  specValue: (index: number) => `${PREFIX}-spec-${index + 1}-value`,
  specLabel: (index: number) => `${PREFIX}-spec-${index + 1}-label`,
} as const;
